import { useCallback } from 'react';
import { AlertModal } from 'app/shared/components/modals/AlertModal';
import { IDocuSignAlertProps } from './interface';
import { requestDocuSign } from './queries';

export const DocuSignAlert = ({
  openDocuSignAlert,
  setOpenDocuSignAlert,
  dealId,
  documentGeneratedType,
  customDocuSign,
  setLoading,
  setLoaderText,
}: IDocuSignAlertProps) => {

  const onDocuSign = useCallback(async (sendCustomDocuSign: boolean) => {
    const data = {
      dealId: dealId,
      isCustomDocuSign: customDocuSign,
      documentGenerationType: documentGeneratedType,
      shouldSendToCoBorrowerForCustomDocuSign: sendCustomDocuSign,
      requiresDroppedDocuSign: true,
    };

    setOpenDocuSignAlert(false);
    setLoaderText('Sending to DocuSign...');
    setLoading(true);
    await requestDocuSign(data);
    setLoading(false);
    setLoaderText('');
  }, []);

  return (
    <>
      <AlertModal
        title="Docu Sign"
        subtitle="Send document to Co-Borrower?"
        cancelButtonText="No"
        buttonText="Yes"
        open={openDocuSignAlert}
        onConfirm={() => onDocuSign(true)}
        onClose={() => onDocuSign(false)}
      />
    </>
  );
};

